import type { Action, AnyAction } from "@reduxjs/toolkit";
import type { AppThunk } from "./store";

const RESET_STORE = "store/reset" as const;

export const isStoreResetAction = (action: AnyAction): action is Action<typeof RESET_STORE> =>
  action.type === RESET_STORE;

export const resetStore = (): AppThunk => dispatch => dispatch({ type: RESET_STORE });
